// Missions' block vocabulary — what its agent may say that is not prose.
//
// .mjs, NOT .js, and that is load-bearing: this package has no `"type":
// "module"`, so bare Node reads a .js file as CommonJS — and the SERVER imports
// this to build the agent's prompt while Vite imports it for the browser. One
// declaration with two readers only works if both can load it.
//
// ONE DECLARATION, TWO READERS. The kit's parseBlocks runs this to read a reply;
// blockPrompt runs it to write the paragraph the agent reads. Before, the app
// held a hand-written parser and the server held a hand-written paragraph
// describing the same grammar — and the paragraph is the copy that rots quietly,
// because a model given a stale grammar produces plausible output that renders
// as nothing at all.
//
// Every entry maps a missions block onto a KIT card. Nothing here draws.
const item = (key, verb, prompt) => ({
  key,
  card: 'proposal',
  verb,
  kind: '{type}',
  title: '{title}',
  description: '{description}',
  prompt,
});

export const MISSIONS_BLOCKS = [
  item('create', 'create',
    'Propose a new mission, goal, action, habit, event or availability band. '
    + 'One block per item — never bundle several into one.'),
  item('update', 'edit', 'Propose a change to an existing item. Include its id.'),
  item('move', 'move', 'Propose refiling an item under a different parent.'),
  item('delete', 'delete', 'Propose removing an item. Include its id.'),
  item('link', 'link', 'Propose filing a signal against an item.'),
  item('relate', 'relate', 'Propose a relationship between two items.'),
  item('tag', 'tag', 'Propose tagging an item.'),
  {
    key: 'choice',
    family: 'widget',
    card: 'choice',
    example: 'title: Which mission?\noptions:\n- Bonfire presence\n- Don\'t file it',
    prompt: 'Ask a question whose answers you already know. Changes nothing — '
      + 'use it before proposing when the filing is ambiguous.',
  },
];
